import { api } from './client';

export interface SisAvailableLot {
  itemId: number;
  itemCode: string;
  itemName: string;
  itemBarcode: string;
  invoiceNo: string;
  rate: number;
  lotDate: string;
  qtyRemaining: number;
}

export interface SisTransferRow {
  id: number;
  transferNo: string;
  transferDate: string;
  fromStore: string;
  toStore: string;
  group: string;
  remarks: string;
  createdBy: string | null;
  createdAt: string;
  totalQty: number;
  items: {
    itemCode: string;
    itemName: string;
    invoiceNo: string;
    qty: number;
    rate: number;
    lotDate: string;
  }[];
}

export async function listSisTransfers(): Promise<SisTransferRow[]> {
  const r = await api.get<SisTransferRow[]>('/sis-transfer');
  return r.data;
}

export async function availableSisLots(partyId: number): Promise<SisAvailableLot[]> {
  const r = await api.get<SisAvailableLot[]>('/sis-transfer/available', { params: { partyId } });
  return r.data;
}

export async function createSisTransfer(payload: {
  fromPartyId: number;
  toPartyId: number;
  transferDate?: string;
  remarks?: string;
  items: { itemId: number; invoiceNo: string; qty: number }[];
}): Promise<{ id: number; transferNo: string }> {
  const r = await api.post('/sis-transfer', payload);
  return r.data;
}
